import {useQuery} from '@tanstack/react-query'
import api, {ClientInclude} from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  selectedCompanies?: number[]
  includes?: ClientInclude[]
  hasPermission?: boolean
}

export default function useClients({selectedCompanies, includes, hasPermission}: Props) {
  const query = useQuery({
    refetchOnWindowFocus: false,
    enabled: hasPermission,
    queryKey: [QueryKeyEnum.CLIENTS, selectedCompanies, includes],
    queryFn: async () =>
      await api.client.getMany({
        paginate: false,
        filter: {
          companyIds: selectedCompanies,
        },
        includes: includes,
      }),
  })

  return query
}
